// Author YuJiaBei
// Date 2023-08-09 16:39:51

class SithMesPrdPpOperation {
    constructor({
                    id = null,
                    prdPpHeaderId = '',
                    missionMode = '',
                    prdPpStatusCode = '',
                    operationSeq = '',
                    deleteFlag = '',
                    operationDescription = '',
                    workCenterCode = '',
                    ctrlKey = '',
                    operationQuantity = '',
                    systemStatus = '',
                    confirmUser = '',
                    finishQuantity = '',
                    scrap = '',
                    workHour = '',
                    headCount = '',
                    bufferHour = '',
                    transferHour = '',
                    baseBeginTime = '',
                    baseEndTime = '',
                    baseMstLocationId = '',
                    forecastBeginTime = '',
                    forecastFinishTime = '',
                    forecastMstLocationId = '',
                    forecastMstLocationName = '',
                    sapChangedFlag = '',
                    actualBeginTime = '',
                    actualFinishTime = '',
                    actualMstLocationId = '',
                    actualMstLocationName = '',
                    isLocked = '',
                    forecastRemark = '',
                    actualExecutionRemark = '',
                    manHour = '',
                    machineHour = '',
                    manHourUnit = '',
                    machineHourUnit = '',
                    workHourUnit = '',
                    forecastBeginDeviation = '',
                    forecastEndDeviation = '',
                    remark = '',
                    baselineBeginTime = '',
                    baselineFinishTime = '',
                    sapRewriteStatus = '',
                    poNumber = '',
                    poItemNumber = '',
                    prNumber = '',
                    prItemNumber = '',
                    toolsNeed = '',
                    toolsRelateStatus = '',
                    programName = '',
                    riskFactor = ''
                }
                    = {}) {
        this.id = id;
        this.prdPpHeaderId = prdPpHeaderId;
        this.missionMode = missionMode;
        this.prdPpStatusCode = prdPpStatusCode;
        this.operationSeq = operationSeq;
        this.deleteFlag = deleteFlag;
        this.operationDescription = operationDescription;
        this.workCenterCode = workCenterCode;
        this.ctrlKey = ctrlKey;
        this.operationQuantity = operationQuantity;
        this.systemStatus = systemStatus;
        this.confirmUser = confirmUser;
        this.finishQuantity = finishQuantity;
        this.scrap = scrap;
        this.workHour = workHour;
        this.headCount = headCount;
        this.bufferHour = bufferHour;
        this.transferHour = transferHour;
        this.baseBeginTime = baseBeginTime;
        this.baseEndTime = baseEndTime;
        this.baseMstLocationId = baseMstLocationId;
        this.forecastBeginTime = forecastBeginTime;
        this.forecastFinishTime = forecastFinishTime;
        this.forecastMstLocationId = forecastMstLocationId;
        this.forecastMstLocationName = forecastMstLocationName;
        this.sapChangedFlag = sapChangedFlag;
        this.actualBeginTime = actualBeginTime;
        this.actualFinishTime = actualFinishTime;
        this.actualMstLocationId = actualMstLocationId;
        this.actualMstLocationName = actualMstLocationName;
        this.isLocked = isLocked;
        this.forecastRemark = forecastRemark;
        this.actualExecutionRemark = actualExecutionRemark;
        this.manHour = manHour;
        this.machineHour = machineHour;
        this.manHourUnit = manHourUnit;
        this.machineHourUnit = machineHourUnit;
        this.workHourUnit = workHourUnit;
        this.forecastBeginDeviation = forecastBeginDeviation;
        this.forecastEndDeviation = forecastEndDeviation;
        this.remark = remark;
        this.baselineBeginTime = baselineBeginTime;
        this.baselineFinishTime = baselineFinishTime;
        this.sapRewriteStatus = sapRewriteStatus;
        this.poNumber = poNumber;
        this.poItemNumber = poItemNumber;
        this.prNumber = prNumber;
        this.prItemNumber = prItemNumber;
        this.toolsNeed = toolsNeed;
        this.toolsRelateStatus = toolsRelateStatus;
        this.programName = programName;
        this.riskFactor = riskFactor;
    }
}

function newEntity() {
    return new SithMesPrdPpOperation();
}

const schedulingVoConfigs = [
    {
        key: 'missionMode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.missionMode',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '自动计划'},
                {value: '2', text: '手动计划'}
            ]
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeNew',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCodeNew',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine2',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastMstLocationName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastMstLocationType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: 'machine-工作中心'},
                {value: '2', text: 'man-工作中心'},
                {value: '3', text: 'virtual'},
                {value: '4', text: '公司'},
                {value: '5', text: '部门'},
                {value: '6', text: '成本中心'},
                {value: '7', text: '工位'}
            ]
        }
    },
    {
        key: 'actualMstLocationName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualMstLocationName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpStatusName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpStatusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpHeaderStatusCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpHeaderStatusCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.ppHeaderType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationSeq',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDescription',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationDescription',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.wbsCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrder',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.salesOrder',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpHeaderId',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpHeaderId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderType',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'material_bom',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialDescription',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deleteFlag',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.deleteFlag',
        sortable: true,
        isDetail: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workCenterCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workCenterCode',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ctrlKey',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.ctrlKey',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationQuantity',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'systemStatus',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.systemStatus',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmUser',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.confirmUser',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finishQuantity',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.finishQuantity',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'scrap',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.scrap',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'headCount',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.headCount',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'usedWorkHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.usedWorkHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourPercent',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourPercent',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstPendingWorkHourRecordStartTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.firstPendingWorkHourRecordStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bufferHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.bufferHour',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transferHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.transferHour',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseBeginTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseEndTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseEndTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'priority',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.priority',
        sortable: true,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseMstLocationId',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseMstLocationId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.isLocked',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastRemark',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastRemark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualExecutionRemark',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualExecutionRemark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapChangedFlag',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapChangedFlag',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未变化'},
                {value: '1', text: '从未释放到已释放'},
                {value: '2', text: '关键信息变更'},
                {value: '3', text: '删除'}
            ]
        }
    },
    {
        key: 'manHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviation',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastBeginDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviation',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastEndDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'programName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.programName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapRewriteStatus',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '回写成功'},
                {value: '2', text: '回写失败'},
                {value: '3', text: '跳过回写'},
                {value: '4', text: '等待回写'},
                {value: '5', text: '回写中'}
            ]
        }
    },
    {
        key: 'sapRewriteMessage',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteMessage',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.poNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.poItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'toolsNeed',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.toolsNeed',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'toolsRelateStatus',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.toolsRelateStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未上挂'},
                {value: '2', text: '已上挂'}
            ]
        }
    },
    {
        key: 'riskFactor',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.riskFactor',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manualPreDependencies',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.manualPreDependencies',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourWithRiskFactor',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourWithRiskFactor',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]
const dispatchVoConfigs = [
    {
        key: 'missionMode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.missionMode',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '自动计划'},
                {value: '2', text: '手动计划'}
            ]
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeNew',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCodeNew',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine2',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastMstLocationName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastMstLocationType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: 'machine-工作中心'},
                {value: '2', text: 'man-工作中心'},
                {value: '3', text: 'virtual'},
                {value: '4', text: '公司'},
                {value: '5', text: '部门'},
                {value: '6', text: '成本中心'},
                {value: '7', text: '工位'}
            ]
        }
    },
    {
        key: 'prdPpStatusName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpStatusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpHeaderStatusCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpHeaderStatusCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.ppHeaderType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationSeq',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDescription',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationDescription',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastBeginTime',
        sortable: true,
        form: {
            type: 'input',
            //已下发未派工的工序，计划开始时间提前2天变黄，超过今天的变红
            customClass: (row) => {
                if (row.prdPpStatusName === '已下发' && row.forecastBeginTime) {
                    let currTime = new Date()
                    currTime.setHours(0, 0, 0, 0)
                    let warnTime = new Date().setDate(currTime.getDate() + 2);
                    //把字符串格式转化为日期类
                    let forecastBeginTime = new Date(Date.parse(row.forecastBeginTime))
                    if (forecastBeginTime < currTime)
                        return "bg-danger text-white"
                    else if (forecastBeginTime < warnTime)
                        return "bg-warning text-dark"
                }
                return ""
            }
        }
    },
    {
        key: 'forecastFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchUserNames',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.dispatchUserNames',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderType',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'material_bom',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialDescription',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationQuantity',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'usedWorkHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.usedWorkHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourPercent',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourPercent',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstPendingWorkHourRecordStartTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.firstPendingWorkHourRecordStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'programName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.programName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapRewriteStatus',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '回写成功'},
                {value: '2', text: '回写失败'},
                {value: '3', text: '跳过回写'},
                {value: '4', text: '等待回写'},
                {value: '5', text: '回写中'}
            ]
        }
    },
    {
        key: 'sapRewriteMessage',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteMessage',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'missionMode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.missionMode',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '自动计划'},
                    {value: '2', text: '手动计划'}
                ]
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCodeNew',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCodeNew',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectMachine1',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectMachine2',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine2',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastMstLocationName',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastMstLocationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastMstLocationType',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastMstLocationType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: 'machine-工作中心'},
                    {value: '2', text: 'man-工作中心'},
                    {value: '3', text: 'virtual'},
                    {value: '4', text: '公司'},
                    {value: '5', text: '部门'},
                    {value: '6', text: '成本中心'},
                    {value: '7', text: '工位'}
                ]
            }
        },
        {
            key: 'actualMstLocationName',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualMstLocationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpStatusName',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpStatusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpHeaderStatusCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpHeaderStatusCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppHeaderType',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.ppHeaderType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '未替换'},
                    {value: '2', text: '已替换'},
                    {value: '3', text: '虚拟'}
                ]
            }
        },
        {
            key: 'operationSeq',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationSeq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationDescription',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationDescription',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastFinishTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastFinishTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualFinishTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualFinishTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchUserNames',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.dispatchUserNames',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.wbsCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrder',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.salesOrder',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpHeaderId',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpHeaderId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderType',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'material_bom',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialDescription',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headerDeadLineFinishTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.headerDeadLineFinishTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headerBornlineBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.headerBornlineBeginTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headerBasicStartTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.headerBasicStartTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headerBasicFinishTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.headerBasicFinishTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deleteFlag',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.deleteFlag',
            sortable: true,
            isDetail: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workCenterCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.workCenterCode',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ctrlKey',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.ctrlKey',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationQuantity',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'systemStatus',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.systemStatus',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'confirmUser',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.confirmUser',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'finishQuantity',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.finishQuantity',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'scrap',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.scrap',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHour',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headCount',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.headCount',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'usedWorkHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.usedWorkHour',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workHourPercent',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourPercent',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'firstPendingWorkHourRecordStartTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.firstPendingWorkHourRecordStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bufferHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.bufferHour',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transferHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.transferHour',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baseBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseBeginTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baseEndTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseEndTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'priority',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.priority',
            sortable: true,
            form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baseMstLocationId',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseMstLocationId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isLocked',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.isLocked',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastRemark',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastRemark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualExecutionRemark',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualExecutionRemark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapChangedFlag',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapChangedFlag',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '未变化'},
                    {value: '1', text: '从未释放到已释放'},
                    {value: '2', text: '关键信息变更'},
                    {value: '3', text: '删除'}
                ]
            }
        },
        {
            key: 'manHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHour',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'machineHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHour',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'manHourUnit',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHourUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'machineHourUnit',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHourUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workHourUnit',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastBeginDeviation',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastBeginDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastEndDeviation',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastEndDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'programAttachments',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.programAttachments',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'programAttachmentsList',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.programAttachmentsList',
            sortable: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'programName',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.programName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineFinishTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineFinishTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapRewriteStatus',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '回写成功'},
                    {value: '2', text: '回写失败'},
                    {value: '3', text: '跳过回写'},
                    {value: '4', text: '等待回写'},
                    {value: '5', text: '回写中'}
                ]
            }
        },
        {
            key: 'sapRewriteMessage',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteMessage',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poNumber',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItemNumber',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.poItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prNumber',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.prNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prItemNumber',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.prItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'toolsNeed',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.toolsNeed',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'toolsRelateStatus',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.toolsRelateStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '未上挂'},
                    {value: '2', text: '已上挂'}
                ]
            }
        },
        {
            key: 'riskFactor',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.riskFactor',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'manualPreDependencies',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.manualPreDependencies',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workHourWithRiskFactor',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourWithRiskFactor',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const executeVoConfigs = [
    {
        key: 'missionMode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.missionMode',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '自动计划'},
                {value: '2', text: '手动计划'}
            ]
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeNew',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectCodeNew',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.projectMachine2',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualMstLocationName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualMstLocationName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpStatusName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpStatusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpHeaderStatusCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpHeaderStatusCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.ppHeaderType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationSeq',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDescription',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationDescription',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchUserNames',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.dispatchUserNames',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.wbsCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpHeaderId',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpHeaderId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderType',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderType',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'material_bom',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialDescription',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workCenterCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workCenterCode',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ctrlKey',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.ctrlKey',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationQuantity',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'headCount',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.headCount',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'usedWorkHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.usedWorkHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourPercent',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourPercent',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstPendingWorkHourRecordStartTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.firstPendingWorkHourRecordStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.manHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.machineHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHourUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'programName',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.programName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.baselineFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapRewriteStatus',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '回写成功'},
                {value: '2', text: '回写失败'},
                {value: '3', text: '跳过回写'},
                {value: '4', text: '等待回写'},
                {value: '5', text: '回写中'}
            ]
        }
    },
    {
        key: 'sapRewriteMessage',
        label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapRewriteMessage',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idInFilter: [],
    projectCodeFilter: '',
    projectCodeNewFilter: '',
    projectMachine1Filter: '',
    projectMachine1NewFilter: '',
    projectMachine2Filter: '',
    forecastMstLocationIdFilter: '',
    forecastMstLocationNameFilter: '',
    priorityFilter: '',
    forecastMstLocationTypeFilter: '',
    prdPpStatusCodeFilter: '',
    wbsCodeFilter: '',
    headerParentIdFilter: '',
    parentOrderCodeFilter: '',
    orderCodeFilter: '',
    materialDescriptionFilter: '',
    ppHeaderTypeFilter: '',
    forecastBeginTimeRteFilter: '',
    forecastBeginTimeLteFilter: '',
    forecastFinishTimeRteFilter: '',
    forecastFinishTimeLteFilter: '',
    workHourFilter: '',
    workHourGTFilter: '',
    workHourLTFilter: '',
    prdPpHeaderIdFilter: '',
    prdPpHeaderIdInFilter: [],
    wbsCodeStartsWithFilter: '',
    missionModeFilter: '',
    prdPpStatusCodeInFilter: [],
    prdPpStatusCodeGteFilter: '',
    prdPpStatusCodeLteFilter: '',
    materialCodeFilter: '',
    deleteFlagFilter: '',
    operationDescriptionFilter: '',
    workCenterCodeFilter: '',
    ctrlKeyFilter: '',
    sapChangedFlagFilter: '',
    baseBeginTimeRteFilter: '',
    baseBeginTimeLteFilter: '',
    baseEndTimeRteFilter: '',
    baseEndTimeLteFilter: '',
    baseMstLocationIdFilter: '',
    forecastMstLocationIdInFilter: [],
    actualBeginTimeRteFilter: '',
    actualBeginTimeLteFilter: '',
    actualFinishTimeRteFilter: '',
    actualFinishTimeLteFilter: '',
    forecastBeginDeviationRteFilter: '',
    forecastBeginDeviationLteFilter: '',
    forecastEndDeviationRteFilter: '',
    forecastEndDeviationLteFilter: '',
    actualMstLocationIdFilter: '',
    actualMstLocationNameFilter: '',
    isLockedFilter: '',
    forecastRemarkFilter: '',
    actualExecutionRemarkFilter: '',
    isAttachmentUploadedFilter: '',
    sapRewriteStatusFilter: '',
    poNumberFilter: '',
    poItemNumberFilter: '',
    prNumberFilter: '',
    prItemNumberFilter: '',
    bufferHourFilter: '',
    transferHourFilter: '',
    headCountFilter: '',
    manHourFilter: '',
    machineHourFilter: '',
    orderTypeFilter: '',
    toolsNeedFilter: '',
    toolsRelateStatusFilter: '',
    programNameFilter: '',
    riskFactorFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeNewFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectCodeNew',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1Filter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1NewFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine1New',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2Filter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine2',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastMstLocationName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"forecastMstLocationId":"id"}'
        }
    },
    {
        key: 'priorityFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.priority',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastMstLocationType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'machine-工作中心'},
                {value: '2', text: 'man-工作中心'},
                {value: '3', text: 'virtual'},
                {value: '4', text: '公司'},
                {value: '5', text: '部门'},
                {value: '6', text: '成本中心'},
                {value: '7', text: '工位'}
            ]
        }
    },
    {
        key: 'prdPpStatusCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpStatusCode',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'wbsCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.wbsCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.parentOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.materialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.ppHeaderType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.workHour',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourGTFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.workHourGT',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourLTFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.workHourLT',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpHeaderIdFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpHeaderId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'missionModeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.missionMode',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '自动计划'},
                {value: '2', text: '手动计划'}
            ]
        }
    },
    {
        key: 'prdPpStatusCodeInFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpStatusCodeIn',
        disabled: false,
        form: {
            type: 'entitySelectMultiple',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpStatus'
            , correspondingField: 'id'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.operationDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workCenterCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.workCenterCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ctrlKeyFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.ctrlKey',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapChangedFlagFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.sapChangedFlag',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未变化'},
                {value: '1', text: '从未释放到已释放'},
                {value: '2', text: '关键信息变更'},
                {value: '3', text: '删除'}
            ]
        }
    },
    {
        key: 'baseBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.baseBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.baseBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.actualBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.actualBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.actualFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.actualFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastEndDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastEndDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.actualMstLocationName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"actualMstLocationId":"id"}'
        }
    },
    {
        key: 'actualMstLocationNameInputFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.actualMstLocationNameInput',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isLockedFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.isLocked',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAttachmentUploadedFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.isAttachmentUploaded',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapRewriteStatusFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.sapRewriteStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '回写成功'},
                {value: '2', text: '回写失败'},
                {value: '3', text: '跳过回写'},
                {value: '4', text: '等待回写'},
                {value: '5', text: '回写中'}
            ]
        }
    },
    {
        key: 'poNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.poItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bufferHourFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.bufferHour',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transferHourFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.transferHour',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'headCountFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.headCount',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHourFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.manHour',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHourFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.machineHour',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.orderType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'toolsNeedFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.toolsNeed',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'toolsRelateStatusFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.toolsRelateStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '未上挂'},
                {value: '2', text: '已上挂'}
            ]
        }
    },
    {
        key: 'programNameFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.programName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'riskFactorFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.riskFactor',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];
const schedulingFilterConfigs = [
    {
        key: 'priorityFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.priority',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];
const dispatchFilterConfigs = [
    {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeNewFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectCodeNew',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1Filter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1NewFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine1New',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2Filter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine2',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastMstLocationName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"forecastMstLocationId":"id"}'
        }
    },
    {
        key: 'forecastMstLocationTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastMstLocationType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'machine-工作中心'},
                {value: '2', text: 'man-工作中心'},
                {value: '3', text: 'virtual'},
                {value: '4', text: '公司'},
                {value: '5', text: '部门'},
                {value: '6', text: '成本中心'},
                {value: '7', text: '工位'}
            ]
        }
    },
    {
        key: 'prdPpStatusCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpStatusCode',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'wbsCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.wbsCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.materialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.ppHeaderType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];
const executeFilterConfigs = [
    {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeNewFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectCodeNew',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1Filter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1NewFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine1New',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2Filter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.projectMachine2',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastMstLocationName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"forecastMstLocationId":"id"}'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.ppHeaderType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpHeaderIdFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpHeaderId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'prdPpStatusCodeInFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpStatusCodeIn',
        disabled: false,
        form: {
            type: 'entitySelectMultiple',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpStatus'
            , correspondingField: 'id'
        }
    },
    {
        key: 'operationDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.operationDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workCenterCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.workCenterCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.baseBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.baseBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.actualMstLocationName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"actualMstLocationId":"id"}'
        }
    }
];


const executeEntityConfigs = [
    {
        key: 'headCount',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.headCount',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
]
const entityFormConfigs = [
    {
        key: 'prdPpHeaderId',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.prdPpHeaderId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'missionMode',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.missionMode',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '自动计划'},
                {value: '2', text: '手动计划'}
            ]
        }
    },
    {
        key: 'prdPpStatusCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.prdPpStatusCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'sithMesPrdPpStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.operationSeq',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'deleteFlag',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.deleteFlag',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDescription',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.operationDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'workCenterCode',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.workCenterCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'ctrlKey',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.ctrlKey',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationQuantity',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.operationQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'systemStatus',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.systemStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmUser',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.confirmUser',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finishQuantity',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.finishQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'scrap',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.scrap',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.workHour',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'headCount',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.headCount',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bufferHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.bufferHour',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transferHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.transferHour',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.baseBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseEndTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.baseEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseMstLocationId',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.baseMstLocationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.forecastBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.forecastFinishTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastMstLocationName',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.forecastMstLocationName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"forecastMstLocationId":"id"}'
        }
    },
    {
        key: 'actualBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.actualBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishTime',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.actualFinishTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualMstLocationName',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.actualMstLocationName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"actualMstLocationId":"id"}'
        }
    },
    {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.isLocked',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastRemark',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.forecastRemark',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualExecutionRemark',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.actualExecutionRemark',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.manHour',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHour',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.machineHour',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'manHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.manHourUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.machineHourUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workHourUnit',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.workHourUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviation',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.forecastBeginDeviation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviation',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.forecastEndDeviation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.poNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.poItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.prNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemNumber',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.prItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'programName',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.programName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'riskFactor',
        label: 'label.sith.prd.sithMesPrdPpOperation.entity.riskFactor',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesPrdPpOperation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, schedulingFilterConfigs, dispatchFilterConfigs, executeFilterConfigs
    , executeEntityConfigs
    , schedulingVoConfigs, dispatchVoConfigs, executeVoConfigs
}
